<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex lg12>
        <v-select :items="responsible_originators" v-model="responsible_originator" placeholder="Select Commercial Originator" class="dropdown" item-value="userid" item-text="fullName" solo outline></v-select>
      </v-flex>

      <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
        <div style="float: right">
          <v-btn  class="text-xs-right elevation-5" color="info" @click.stop="fncSaveKam">Save Responsible Originator</v-btn>
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
          <small>* The button will activate once all required fields have been completed</small>
        </div>
      </div>
    </v-layout>

  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Swatches from 'vue-swatches';
  import "vue-swatches/dist/vue-swatches.min.css";

  export default {
    name: 'Settings',
    components: { Swatches },
    data () {
      return {
        search: '',
        loading: true,
        responsible_originator: '',
        responsible_originators: []
      };
    },
    methods: {
      fncSaveKam() {
        this.$store.dispatch({
          type: 'fncUpdateCommercialOriginator',
          quote: this.globalModalParams.quote.id,
          originator: this.responsible_originator
        })
      },
      fncHideModal () {
        setTimeout(function() {
          location.reload();
        }, 1000)
      }
    },
    mounted() {
      console.log( this.globalModalParams );
      this.responsible_originator = this.globalModalParams.quote.responsible_originator;
      this.responsible_originators = this.globalModalParams.originators;
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams'
      ])
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
